"use client";
import { TenderCard } from "@/components/TenderCard/TenderCard";
import { Layout } from "@/components/Layout/Layout";
import { HeroHeader } from "@/components/HeroHeader/HeroHeader";
export default function Wrapper({ pageData, tenders }) {
    return (
        <Layout lightHeader={false}>
            <HeroHeader
                heading={pageData.banner.title}
                subHeading={pageData.banner.text}
            />

            <section className="py-8 lg:py-16 bg-blue">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-y-5 gap-x-6 w-full hp-container">
                    {tenders.map((tender) => {
                        return (
                            <TenderCard
                                title={tender.title}
                                link={tender.doc.url}
                                key={tender.id}
                            />
                        );
                    })}
                </div>
            </section>
        </Layout>
    );
}
